import { socket } from "../socket.ts";
import { BaseCommand } from "../commandTypes.ts";
import { useEffect, useCallback } from "react";

export const useCommand = <T extends BaseCommand>(
  c: string,
  f: (command: T) => void,
) => {
  const stableCallback = useCallback(f, [f]);

  useEffect(() => {
    const handleCommand = (command: T) => {
      if (command.command == c) {
        stableCallback(command);
      }
    };

    socket.on("command", handleCommand);

    return () => {
      socket.off("command", handleCommand);
    };
  }, [c, stableCallback]);
};
